import React, { useEffect } from 'react';
import SelectField from 'Shared/form/SelectField';
import { Col, Row } from 'react-bootstrap';
import PublisherTable from 'App/components/PublisherTable/PublisherTable';
import { useFormikContext } from 'formik';
import * as R from 'ramda';
import useFectchUnpublishedContent from './hooks/useFectchUnpublishedContent';

const contentTypeList = [
    {
        name: 'Drug monograph',
        id: 'drug',
    },
    {
        name: 'Disease monograph',
        id: 'disease',
    },
    {
        name: 'Teaching point monograph',
        id: 'teaching',
    },
];

const ContentPublisherForm = () => {
    const { values, setFieldValue, validateForm, isSubmitting } = useFormikContext();
    const { rawList, isLoading } = useFectchUnpublishedContent(values?.monographType?.id);

    useEffect(() => {
        if (values?.monographType?.id && rawList.length > 0 && !isLoading) {
            setFieldValue('availableRecords', rawList);
            setFieldValue('selectedRecords', []);
        }
    }, [setFieldValue, rawList, values?.monographType?.id, isLoading]);

    useEffect(() => {
        validateForm();
    }, [validateForm, values.selectedRecords]);

    const onMonographTypeChange = (selectedOption) => {
        if (!selectedOption?.id) {
            setFieldValue('availableRecords', []);
            setFieldValue('selectedRecords', []);
        }
        setFieldValue('monographType', selectedOption || null);
    };

    const onActionClick = (item, moveTo) => {
        const { availableRecords, selectedRecords } = values;

        if (moveTo === 'selected') {
            setFieldValue(
                'availableRecords',
                availableRecords.filter((i) => i.id !== item.id)
            );
            setFieldValue('selectedRecords', [...selectedRecords, item]);
        } else {
            setFieldValue(
                'selectedRecords',
                selectedRecords.filter((i) => i.id !== item.id)
            );
            setFieldValue('availableRecords', [...availableRecords, item]);
        }
    };

    return (
        <>
            <Row>
                <Col md={6}>
                    <SelectField
                        options={contentTypeList}
                        isClearable
                        required
                        label="Select the monograph type"
                        fieldName="monographType"
                        getOptionValue={R.prop('id')}
                        getOptionLabel={R.prop('name')}
                        onChange={onMonographTypeChange}
                        disabled={isSubmitting || isLoading}
                    />
                </Col>
            </Row>
            <PublisherTable
                tableName="Monographs"
                availableRecords={values.availableRecords}
                selectedRecords={values.selectedRecords}
                onActionClick={onActionClick}
                isLoading={isLoading}
            />
        </>
    );
};

export default ContentPublisherForm;
